"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicEditor = void 0;
var React = __importStar(require("react"));
var constants_1 = __importDefault(require("../../constants"));
var customTextEditorToolbar = __assign({}, constants_1.default.EDITOR_DEFAULT_MODE);
var DynamicEditor = /** @class */ (function (_super) {
    __extends(DynamicEditor, _super);
    function DynamicEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.emptyBlock = '<p><br></p>';
        var toolbarOptions = _this.props.toolbarOptions;
        var toolbarConfiguration = _this.props.toolbarConfiguration ? __assign({}, _this.props.toolbarConfiguration) : __assign({}, customTextEditorToolbar);
        if (!_this.props.toolbarConfiguration && toolbarOptions && toolbarOptions.length > 0) {
            toolbarConfiguration = __assign(__assign({}, toolbarConfiguration), { toolbar: [__spreadArray([], toolbarOptions, true)] });
        }
        _this.state = {
            editorValue: _this.props.enableHtmlEditor ? '' : null,
            toolbarConfiguration: toolbarConfiguration,
        };
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onPaste = _this.onPaste.bind(_this);
        _this.onEditorChange = _this.onEditorChange.bind(_this);
        return _this;
    }
    DynamicEditor.prototype.componentDidMount = function () {
        if (this.props.enableHtmlEditor) {
            var editorValue = this.props.value;
            this.setState({ editorValue: editorValue });
        }
    };
    DynamicEditor.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var togglingHtmlEditorOn = nextProps.enableHtmlEditor && nextProps.enableHtmlEditor !== this.props.enableHtmlEditor;
        var dataChangeFromOutside = this.props.value !== nextProps.value;
        // NOTE: because we maintain an internal state of the editorState, the incoming value must be compared to the HTML
        // 		 stored on the state's editorState and not this.props.value
        if (this.state.editorValue) {
            var previousHtml = this.state.editorValue;
            dataChangeFromOutside = nextProps.value !== undefined && previousHtml !== nextProps.value && nextProps.value !== this.emptyBlock;
        }
        if (togglingHtmlEditorOn || dataChangeFromOutside) {
            this.setState({ editorValue: nextProps.value });
        }
    };
    DynamicEditor.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    DynamicEditor.prototype.onChange = function (e) {
        var _a = this.props, onChange = _a.onChange, value = _a.value;
        var text = this.getHtmlAsString(e);
        if (onChange && text !== value) {
            onChange(text, e || {});
        }
    };
    DynamicEditor.prototype.onBlur = function (e) {
        var _a = this.props, onBlur = _a.onBlur, onChange = _a.onChange, value = _a.value;
        var text = value;
        if (e.target && e.target.value) {
            text = this.getHtmlAsString(e);
        }
        if (onBlur) {
            onBlur(text, e);
        }
        else if (onChange && text && e) {
            onChange(text, e);
        }
    };
    // In order for the onChange handler to return to the caller what the user's expected input HTML is, it
    // must first set the state with the editorState from the onEditorStateChange handler THEN
    // call getCurrentContent on the editor state and convert the state to HTML.
    DynamicEditor.prototype.onEditorChange = function (value) {
        var onChange = this.props.onChange;
        var text = this.state.editorValue;
        if (onChange && text !== value) {
            onChange(value, {});
        }
    };
    DynamicEditor.prototype.onPaste = function (e) {
        var onPaste = this.props.onPaste;
        if (onPaste) {
            onPaste(e);
        }
    };
    DynamicEditor.prototype.getHtmlAsString = function (e) {
        var value = '';
        if (e && e.target) {
            value = e.target.value === this.emptyBlock ? '' : e.target.value;
        }
        else {
            value = e === this.emptyBlock ? '' : e;
        }
        if (value && this.props.enableHtmlEditor && this.props.inputType === 'input') {
            value = value.replace(/<p>|<\/p>/gi, '');
            value = value.replace(/&nbsp;/gi, ' '); // replace html space characters
        }
        return value;
    };
    DynamicEditor.defaultProps = {
        htmlEditorMode: 'custom',
        readOnly: false,
        toolbarOptions: ['Bold', 'Italic'],
    };
    return DynamicEditor;
}(React.Component));
exports.DynamicEditor = DynamicEditor;
